module.exports = __webpack_public_path__ + "static/media/tech_arp.1befa539.pdf";